import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { Services } from "@/components/landing/Services";
import { Calculator } from "@/components/landing/Calculator";
import { About } from "@/components/landing/About";
import { Team } from "@/components/landing/Team";
import { FullBleed } from "@/components/landing/FullBleed";
import { Booking } from "@/components/landing/Booking";
import { Contact } from "@/components/landing/Contact";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.07, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -70, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(frame);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="relative bg-[#FBF7F2] text-[#493E38] min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Calculator />
        <About />
        <Team />
        <FullBleed />
        <Booking />
        <Contact />
      </main>
      <Toaster theme="light" position="bottom-right" />
    </div>
  );
}
